import React, { useState, useEffect } from 'react';
import axios from 'axios';

function TalentCommunity() {
    const [talents, setTalents] = useState([]);
    const [selectedTalent, setSelectedTalent] = useState(null); // Track the talent being viewed

    useEffect(() => {
        fetchTalents();
    }, []);

    const fetchTalents = async () => {
        try {
            const token = localStorage.getItem('accessToken');
            const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/jobs/gettalentcommunity`, {
                headers: { 'Authorization': `Bearer ${token}` }
            }); // Replace with your API endpoint
            setTalents(response.data);
        } catch (error) {
            console.error('Error fetching talents:', error);
        }
    };

    const handleViewTalent = (talent) => {
        setSelectedTalent(talent);
    };

    return (
        <div className="grid grid-cols-1 gap-4">

            <h2 className="text-lg font-bold text-[#2c2c2c]">Talent Community</h2>

            <div className="space-y-4">
                {talents.map((talent) => (
                    <div key={talent._id} className="bg-[#fff] text-black p-4 rounded shadow">
                        <h3 className="text-lg font-bold">{talent.name}</h3>
                        <p>{talent.email}</p>
                        <div className="mt-4 flex gap-2">
                            <button
                                className="bg-blue-500 hover:bg-blue-600 text-white py-2 px-4 rounded-md"
                                onClick={() => handleViewTalent(talent)}
                            >
                                View
                            </button>
                        </div>
                    </div>
                ))}
            </div>

            {selectedTalent && (
                <div
                    className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center overflow-y-auto"
                    onClick={(e) => {
                        if (e.target === e.currentTarget) {
                            setSelectedTalent(null);
                        }
                    }}
                >
                    <div className="bg-white p-4 rounded max-w-lg w-full m-4 overflow-y-auto max-h-[90vh]">
                        <h2 className="text-2xl font-bold mb-4">{selectedTalent.name}</h2>
                        <p className="mb-2">
                            <strong>Email:</strong> {selectedTalent.email}
                        </p>
                        {selectedTalent.location && (
                            <p className="mb-2">
                                <strong>Location:</strong> {selectedTalent.location}
                            </p>
                        )}
                        {selectedTalent.interest && (
                            <p className="mb-2">
                                <strong>Interest:</strong> {selectedTalent.interest}
                            </p>
                        )}
                        {selectedTalent.resumeURL && (
                            <p className="mb-2">
                                <strong>Resume:</strong>
                                <a
                                    href={selectedTalent.resumeURL}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="text-blue-600 underline"
                                >
                                    View Resume
                                </a>
                            </p>
                        )}
                        <p className="mb-2">
                            <strong>Submitted On:</strong> {new Date(selectedTalent.createdAt).toLocaleString()}
                        </p>
                        <button
                            className="bg-gray-300 px-4 py-2 rounded mt-4"
                            onClick={() => setSelectedTalent(null)}
                        >
                            Close
                        </button>
                    </div>
                </div>
            )}
        </div>
    );
}

export default TalentCommunity;